import history from '@src/history'
import { LEFT_SIDE_CANCEL_ICON } from '@src/utility/utils/constants'

export const SET_USER_NAVIGATION = 'SET_USER_NAVIGATION'
export const ADD_EVALUATE_TO_NAVIGATION = 'ADD_EVALUATE_TO_NAVIGATION'
export const REMOVE_ELEMENT = 'REMOVE_ELEMENT'
export const RESET_NAVIGATION_SIDEBAR = 'RESET_NAVIGATION_SIDEBAR'
//import { AddJdToNavigation } from '@store/navbar'

const getfilteredNavigations = (navList = [], role) => {
  return navList.reduce((array, nav) => {
    if (nav.auth) {
      if (nav.auth.includes(role)) {
        array.push(nav)
      }
    } else {
      if (nav.children) {
        nav.children = getfilteredNavigations(nav.children, role)
        array.push(nav)
      } else {
        array.push(nav)
      }
    }
    return array
  }, [])
}

export function getNavigationByUser() {
  return (dispatch, getState) => {
    let { user, navigations = [] } = getState()
    let filteredNavigations = getfilteredNavigations(navigations, user.role)

    dispatch({
      type: SET_USER_NAVIGATION,
      payload: [...filteredNavigations],
    })
  }
}

export function addEvaluateToNavigation(campaign_id, campaign_name) {
  return function (dispatch) {
    console.log('ADDEVALUATE1', campaign_id, campaign_name)
    dispatch({
      type: ADD_EVALUATE_TO_NAVIGATION, //ADD_EVALUATE_TO_NAVIGATION,
      payload: {
        title: 'Campaign -' + campaign_name,
        id: 'campaign_id - ' + campaign_name,
        children: [
          {
            title: 'Campaign Summary',
            id: campaign_id + '-summary',
            navLink: '/evaluateJD/summary/' + campaign_id,
          },
        ],
      },
      campaign_id: campaign_id,
    })
  }
}

export function removeElementFromNavigation(val, campaign_id) {
  return function (dispatch) {
    dispatch({
      type: REMOVE_ELEMENT,
      value: val,
    })

    dispatch({
      type: 'JD_REMOVE_ELEMENT',
      campaign_id: campaign_id,
    })

    dispatch({
      type: 'JD_SETTINGS_REMOVE_ELEMENT',
      campaign_id: campaign_id,
    })

    dispatch({
      type: 'JD_CANDIDATE_REMOVE_ELEMENT',
      campaign_id: campaign_id,
    })

    history.push({
      pathname: '/jd/incomplete/',
    })
  }
}
